;(function () {
    function FilterOverlay(overlay) {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        /**
         * @method cacheDom
         *  assign {jQuery|HTMLElement(s)} to object
         */
        this.cacheDom = function () {}

        /**
         * Add the overlay whenever the form is submitted
         *
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            var form = $('[rel="search-filters"]').find('form')

            $(form).submit(function () {
                overlay.removeClass('search-filters--overlay-hidden')
            })
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.FilterOverlay = window.FilterOverlay || {}

    window.FilterOverlay.FilterOverlay = FilterOverlay
})()

$(document).ready(function () {
    var overlay = $('[rel="search-filters--overlay"]')

    if (overlay) {
        new window.FilterOverlay.FilterOverlay(overlay)
    }
})
